import React, { useState } from "react";
import video_img from '../images/video/dash-video-img.png'
export default function VideoPlayer() {
  const [play, setPlay] = useState(false);

  return (
    <div
      onClick={() => setPlay(true)}
      style={{ cursor: "pointer" }}
    >
      {!play ? (
        <img
          src={video_img}
          alt="Video Thumbnail"
          width="100%"
        />
      ) : (
        <iframe
          width="100%"
          height="606"
          src="https://www.youtube.com/embed/6s-iAMjtZA4?autoplay=1"
          title="YouTube video"
          frameBorder="0"
          allow="autoplay; encrypted-media"
          allowFullScreen
        />
      )}
    </div>
  );
}